<div *ngIf="showBanner" class="smartAppBanner">
  <div class="smartAppBanner__action">
    <button class="smartAppBanner__action__closeBtn" (click)="closeBanner()" aria-label="close"></button>
  </div>

  <figure class="smartAppBanner__figure">
    <vc-sprite-icons name="logo-v" class="smartAppBanner__figure__logo"></vc-sprite-icons>
  </figure>

  <div class="smartAppBanner__info">
    <p class="smartAppBanner__info__appName" i18n="@@SMART_APP_BANNER.APP_NAME">Vestiaire Collective</p>
    <p class="smartAppBanner__info__contextInfo">
      <span *ngIf="osList.isIos" i18n="@@SMART_APP_BANNER.CONTEXT_INFO_IOS">Buy. Sell. Share</span>
      <span *ngIf="osList.isAndroid" i18n="@@SMART_APP_BANNER.CONTEXT_INFO_ANDROID">Buy. Sell. Share</span>
    </p>
    <p class="smartAppBanner__info__note">
      <ng-container *ngFor="let n of [1, 2, 3, 4, 5]">
        <svg class="svg_star--line" viewBox="0 0 103.7 99.3">
          <polygon
            class="svg_star__polygon"
            fill="none"
            vector-effect="non-scaling-stroke"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="4"
            points="52,2.1 63.8,38.4 102,38.4 71.1,60.9 82.9,97.2 52,74.8 21.1,97.2 32.9,60.9 2,38.4 40.2,38.4 "
          />
        </svg>
      </ng-container>
    </p>
  </div>

  <div class="smartAppBanner__action">
    <button class="smartAppBanner__action__openAppBtn" (click)="openLink()">
      <span i18n="@@SMART_APP_BANNER.OPEN_BUTTON">Open</span>
    </button>
  </div>
</div>
